import node from './node'
import analyse from './analyse'
import render from './render'
import search from './search'
import handle from './handle'
import preHandle from './preHandle'
export default {
  namespaced: true,
  modules: {
    node,
    analyse,
    render,
    search,
    handle,
    preHandle,
  },
}
